import React, { useEffect, useState } from "react";
import { Badge, Card, Container, Spinner, Table } from "react-bootstrap";
import { getFeatureList, deleteFeature } from "../../actions/Feature.action";
import { Text } from "@mantine/core";
import { useModals } from "@mantine/modals";
import { AiFillEdit } from "react-icons/ai";
import { BsFileEarmarkPlus, BsTrash } from "react-icons/bs";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import styles from "./FeatureList.module.css";

const FeatureList = ({ list, getFeatureList, deleteFeature }) => {
  const [rawList, setRawList] = useState(list === null ? [] : list);

  const modals = useModals();

  useEffect(() => {
    if (list === null) {
      getFeatureList();
    }
    if (list !== null) {
      setRawList(list);
    }
  }, [list]);

  const deleteHandeler = (id) =>
    modals.openConfirmModal({
      title: "Delete this link",
      centered: true,
      children: (
        <Text size="md">
          Are you sure you want to delete this link? This action is destructive
          and you can not undo it.
        </Text>
      ),
      labels: { confirm: "Delete link", cancel: "No don't delete it" },
      confirmProps: { color: "red" },
      onCancel: () => {},
      onConfirm: () => confirmHandeler(id),
    });

  const confirmHandeler = async (id) => {
    let check = await deleteFeature(id);
    if (check === true) {
      toast.success("Link deleted successfully");
    } else {
      toast.error("Something went wrong");
    }
  };

  return (
    <Container className="pb-4">
      <div className="d-flex justify-content-end align-items-center pb-3 ">
        <div className="text-right">
          <Link to="/admin/links/add" className={styles.add}>
            <BsFileEarmarkPlus />
          </Link>
        </div>
      </div>
      <Card className="crd p-md-4 pb-md-0 p-2">
        <Card.Body>
          {rawList === null ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: 600 }}
            >
              <Spinner variant="dark" animation="grow" />
            </div>
          ) : rawList.length === 0 ? (
            <span className="text-center fs-4 d-block pb-3">No Link Found</span>
          ) : (
            <>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>
                      <div className="d-flex justify-content-center align-items-center">
                        Actions
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rawList !== null &&
                    rawList.map((gradeItem, i) => (
                      <tr key={gradeItem.id}>
                        <td>{i + 1}</td>
                        <td>{gradeItem.name}</td>
                        <td>{gradeItem.description}</td>
                        <td>
                          {gradeItem.active === true ? (
                            <Badge bg="success">Active</Badge>
                          ) : (
                            <Badge bg="danger">Inactive</Badge>
                          )}
                        </td>
                        <td>
                          <div className="d-flex justify-content-center align-items-center">
                            <Link
                              to={`/admin/links/${gradeItem.id}/edit`}
                              className={` fw-bold  me-4 ${styles.link}`}
                            >
                              <AiFillEdit />
                            </Link>
                            <span
                              onClick={() => deleteHandeler(gradeItem.id)}
                              className={` fw-bold  ${styles.link}`}
                            >
                              <BsTrash />
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  list: state.feature.feature,
});

export default connect(mapStateToProps, { getFeatureList, deleteFeature })(
  FeatureList
);
